import PropTypes from 'prop-types';
import React from 'react';

//lodash
import get from 'lodash/get';

//helpers
import {styleable} from 'decorators';
import {NormalizedSearchResultPropType} from 'utils/search-result-utils';

//components
import {TextDesktop, TextMobile} from 'components/Text';

//styled-components
import {
  Chevron,
  ContentWrapper,
  StyledCloudinaryPicture,
  StyledHeadingDesktop,
  StyledHeadingMobile,
  ResultRow
} from './styles';

const origin = window.location.origin;

const ResultRowBase = styleable(
  ({
    result: {
      guideTitle,
      id,
      index,
      instructionTitle,
      locale,
      media,
      stepCount,
      title,
      topicTitle,
      totalPublishedInstructionsNumber
    },
    device,
    shouldShowShadowOnHover = false,
    shouldShowSpinnerWhileLoading = false
  }) => {
    const isMobile = device === 'mobile';

    const Heading = isMobile ? StyledHeadingMobile : StyledHeadingDesktop;
    const Text = isMobile ? TextMobile : TextDesktop;

    const imageUrl = get(media, 'mediaResource.url');
    const metadata = get(media, 'metadata');

    let extraInformation, subtitle;

    // extract title
    if (index === 'steps') {
      extraInformation = topicTitle
        ? ` < ${instructionTitle} < ${topicTitle} < ${guideTitle}`
        : ` < ${instructionTitle} < ${guideTitle}`;
    } else if (index === 'instructions') {
      extraInformation = topicTitle ? ` < ${topicTitle} < ${guideTitle}` : ` < ${guideTitle}`;
      subtitle = `${stepCount} steps`;
    } else {
      subtitle = `${totalPublishedInstructionsNumber} instructions`;
    }

    return (
      <ResultRow
        data-testid="anchor"
        href={`${origin}/ql/${index}/${id}?locale=${locale}`}
        device={device}
        shouldShowShadowOnHover={shouldShowShadowOnHover}
      >
        <StyledCloudinaryPicture
          metadata={metadata}
          shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
          src={imageUrl}
        />
        <ContentWrapper>
          <Heading maxlines={1} size="xsmall" data-testid="title">
            <b>{title}</b>
            {extraInformation}
          </Heading>
          <Text secondary data-testid="subtitle">
            {subtitle}
          </Text>
        </ContentWrapper>
        {isMobile && <Chevron />}
      </ResultRow>
    );
  }
);

ResultRowBase.propTypes = {
  device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  result: NormalizedSearchResultPropType.isRequired,
  shouldShowShadowOnHover: PropTypes.bool,
  shouldShowSpinnerWhileLoading: PropTypes.bool
};

export const ResultRowDesktop = props => <ResultRowBase device="desktop" {...props} />;

export const ResultRowMobile = props => <ResultRowBase device="mobile" {...props} />;
